<script setup lang="ts">
import {getStateInstance, FileInput} from "../src"; // "@alttiri/vue-file-input"
import {onBeforeUnmount, ref, watchEffect} from "vue";
import {textStyle} from "./core.ts";
import MediaPreview from "./MediaPreview.vue";


console.log("%c[Demo3] The demo is opened.", textStyle);

const [
  state1, state2, state3
] = [...(function * initState() {
  for (let i = 1; i < 4; i++) {
    const state = getStateInstance({recursive: true, debug: true});
    // @ts-ignore
    globalThis[`state${i}`] = state;
    console.log(`%c[Demo3] You can access \`state${i}\` right here in console.`, textStyle, state);
    onBeforeUnmount(() => {
      // @ts-ignore
      delete globalThis[`state${i}`];
    });
    watchEffect(() => {
      if (!state.fileEntries.value.length) { return; }
      console.log(`%c↓↓↓ WebFileEntry ${i} ↓↓↓`, "font-weight: bold;");
      for (const fe of state.fileEntries.value) { console.log(fe); }
    });
    yield state;
  }
})()];

// ---

import Tabs from "./Tabs.vue";
import {defineTab} from "./tabs-helper.ts";

const previewTabs = [
  defineTab({ id: "Media 1", component: MediaPreview }, { state: state1 }),
  defineTab({ id: "Media 2", component: MediaPreview }, { state: state2 }),
  defineTab({ id: "Media 3", component: MediaPreview }, { state: state3 }),
];

// ---

const selectedTabId = ref<string>("");
function selectTabId(num: number) {
  selectedTabId.value = previewTabs[num].id;
}

</script>

<template>
  <div class="c-Demo3" data-component="Demo3">
    <section data-number="0" @pointerenter="selectTabId(0)">
      <div class="header"><strong>FileInput 1</strong></div>
      <FileInput :state="state1" :global-drop-zone="false"/>
      <div class="space" id="space-1"></div>
    </section>
    <hr>
    <section data-number="1" @pointerenter="selectTabId(1)">
      <div class="header"><strong>FileInput 2</strong></div>
      <div class="drop-space" id="drop-space-2">
        <div class="drop-space-pad">
          <FileInput :state="state2" :drop-zone-selector="'#drop-space-2'"/>
        </div>
        <div class="drop-text">Drop Zone 2</div>
      </div>
    </section>
    <hr>
    <section data-number="2" @pointerenter="selectTabId(2)">
      <div class="header"><strong>FileInput 3</strong></div>
      <FileInput :state="state3" :drop-zone-selector="'#drop-space-3'"/>
      <div class="drop-space" id="drop-space-3">
        Drop Zone 3
      </div>
    </section>
    <hr>
    <Tabs :tabs="previewTabs" :keep-alive="true" v-model:selectedTabId="selectedTabId"/>
  </div>
</template>

<style scoped>
[data-component="FileInput"] {
  min-height: 42px;
}

::v-deep([data-component="MediaPreview"] img),
::v-deep([data-component="MediaPreview"] video) {
  min-width: 480px;
  max-width: 100%;
}

pre {
  display: inline;
}
.header {
  margin: 8px 0;
}

.drop-space.drop-hover {
  border: #999 2px dashed;
}

.drop-space {
  margin: 12px 0;
  min-height: 120px;
  border: #ccc 2px dashed;
}
.drop-space-pad {
  padding: 5px;
}
#drop-space-2 .drop-text {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
}
#drop-space-3 {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
}
</style>
